import { Component } from '@angular/core';

@Component({
  selector: 'wm-template-workflow-migration',
  templateUrl: './template-workflow-migration.component.html',
  styleUrls: ['./template-workflow-migration.component.css'],
  standalone: false
})
export class TemplateWorkflowMigrationComponent {
  constructor() {}
}
